<script>
export let currentRoute;


import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Form from 'components/forms/views/form/adult-hockey-free-agent/Form.svelte';


import SvelteSeo from 'svelte-seo';



const forms_api_url = app_.env.FORMS_API_URL;



async function getLeagueInstances() {

	// params ... ?

	const url = `${forms_api_url}/_data/league-instances?season_instance_id=${currentRoute.namedParams.season_instance_id}`;

	const resp = await fetch(url, {
		method: 'GET',	
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}


let promise = getLeagueInstances();


</script>


<style>

</style>


<SvelteSeo
	title='Adult Hockey Free Agent Form | AHG Forms'
	description='Adult Hockey Free Agent Form!'
/>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Adult Free Agent Form
			</p>

		</div>

	</div>
	
</section>


{#await promise}

<Loading />

{:then league_instances}

<section class="section skinny-section">

	<div class="container">

		<MsgCard msg_show={true} msg_text={'By filling out this form you will make your name available to team representatives as a “free agent”. Teams representatives may contact you to become either a part-time or full-time member of their team.'} msg_type={'error'} msg_forever={true} />

		<div class="card form-card">

			<div class="card-content">

				<Form {league_instances} />

			</div>

		</div>


	</div>

</section>

{:catch error}

<section class="section skinny-section">

	<div class="container is-fullwidth">

		<MsgCard msg_show={true} msg_text={error.detail} msg_type={'error'} msg_forever={true} />

	</div>

</section>

{/await}






